import React, { useState } from "react";

const BannerWithForm = () => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    model: "",
    date: "",
    time: "",
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbzJyGh-ifDLL0KuSC2GXLfLN_hEesy3Hcql0c2iZ54qwFwd9JZa_LqWDYxm9zqzyMnI/exec";

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const now = new Date();
    const date = now.toLocaleDateString("en-GB");
    const time = now.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });

    try {
      const formData = new FormData();
      formData.append("name", form.name);
      formData.append("email", form.email);
      formData.append("phone", form.phone);
      formData.append("model", form.model);
      formData.append("date", date);
      formData.append("time", time);

      await fetch(SCRIPT_URL, {
        method: "POST",
        body: formData,
      });

      setSubmitted(true);
      setForm({
        name: "",
        email: "",
        phone: "",
        model: "",
        date: "",
        time: "",
      });
    } catch {
      alert("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="ux-hero">
      <div className="ux-hero-container">
        {/* LEFT BANNER */}
        <div className="ux-hero-left">
          <img
            src="/assets/images/bg/awaneezb.png"
            alt="Banner"
            className="ux-banner-img"
          />
        </div>

        {/* RIGHT FORM */}
        <div className="ux-hero-right">
          {!submitted ? (
            <form className="sx-service-form" onSubmit={handleSubmit}>
              <h3>Petition for Assistance</h3>
              <p>Fill in your details and our team will contact you shortly.</p>

              <div className="sx-form-group">
                <label>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="sx-form-group">
                <label>Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="sx-form-group">
                <label>Phone Number *</label>
                <input
                  type="tel"
                  name="phone"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="sx-form-group">
                <label>Printer Model</label>
                <input
                  type="text"
                  name="model"
                  value={form.model}
                  onChange={handleChange}
                />
              </div>

              <button type="submit" className="sx-form-submit">
                {loading ? "Submitting..." : "Submit Request"}
              </button>
            </form>
          ) : (
            <div className="sx-service-form sx-thankyou">
              <h3>Thank You!</h3>
              <p>
                Your request has been submitted successfully. Our team will
                contact you shortly.
              </p>
            </div>
          )}
        </div>
      </div>

      <style>{`
        /* ===== HERO ===== */
        .ux-hero {
          background: linear-gradient(90deg, #2448a3 0%, #172a6b 38%, #020617 80%);
          padding: 80px 0;
        }

        .ux-hero-container {
          max-width: 1250px;
          margin: auto;
          padding: 0 20px;
          display: flex;
          align-items: center;
          gap: 60px;
        }

        .ux-hero-left,
        .ux-hero-right {
          flex: 1;
        }

        .ux-banner-img {
          max-width: 100%;
          height: auto;
          display: block;
        }

        /* ===== FORM ===== */
        .sx-service-form {
          background: #ffffff;
          padding: 32px;
          border-radius: 14px;
          box-shadow: 0 20px 45px rgba(0,0,0,0.08);
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 16px;
        }

        .sx-service-form h3,
        .sx-service-form p,
        .sx-form-submit {
          grid-column: 1 / -1;
        }

        .sx-form-group label {
          font-size: 13px;
          font-weight: 600;
          margin-bottom: 6px;
          display: block;
        }

        .sx-form-group input {
          width: 100%;
          padding: 12px 14px;
          border-radius: 8px;
          border: 1px solid #d1d5db;
        }

        .sx-form-submit {
          padding: 14px;
          border-radius: 10px;
          border: none;
          background: #3b82f6;
          color: #fff;
          font-weight: 700;
          cursor: pointer;
        }

        /* ===== MOBILE ===== */
        @media (max-width: 900px) {
          .ux-hero-container {
            flex-direction: column;
          }

          .sx-service-form {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
};

export default BannerWithForm;
